var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ring-chart-container",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},[_c('canvas',{ref:_vm.chartId}),_c('div',{staticClass:"ring-chart-value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }